import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initSentry, SentryErrorBoundary } from './lib/sentry'
import { initAnalytics } from './lib/analytics'
import { ErrorFallback } from './components/ErrorFallback'
import './index.css'
import App from './App.tsx'

// Initialize monitoring
initSentry()
initAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <SentryErrorBoundary fallback={ErrorFallback}>
        <App />
      </SentryErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
)
